import _ from 'lodash'
import Backbone from 'backbone'
import MetricComparisonModel from './metric-comparison-model'
import OrganizationsView from './metric-comparison-step1'
import MetricsView from './metric-comparison-step2'
import CalendarView from './metric-comparison-step3'
import * as rangePathValidation from '../common/range-path-validation'
import NewMetricComparisonViewAdapter from './new-metric-comparsion-view-adapter'

function getFilterAttributes(filterOrReportAttributes) {
	//the report attirubtes or the filter attributes can be passed into
	//the validation depending on the context, this function handles so we can
	//validate from either
	return filterOrReportAttributes.filters ?
		filterOrReportAttributes.filters.compareScorecardItems[0] :
		filterOrReportAttributes
}

function orgSelectionView(overrides = {}) {
	return _.extend({
		titleCode: 'report.designer.compareScorecardItems',
		view: OrganizationsView,
		validate: function(attrs, opts) {
			let filter = getFilterAttributes(attrs)
			let notEnoughOrgsSelected = _.get(filter, 'deducedOrgIds', []).length < 2

			let metricOrg = filter.orgAndScorecardRoot
			//only check if set, server will return the valid metric org if any
			let invalidMetricOrg = !_.isNil(metricOrg) && !metricOrg.organizationId

			return notEnoughOrgsSelected || invalidMetricOrg
		}
	}, overrides)
}

function metricSelectionView(overrides = {}) {
	return _.extend({
		titleCode: 'report.designer.compareScorecardItems',
		view: MetricsView,
		validate: function(attrs, opts) {
			let filter = getFilterAttributes(attrs)
			return _.isNil(filter.includeDescendants) || _.isEmpty(filter.includeDescendants)
		}
	}, overrides)
}

const newMetricReportTitle = 'report.metricComparisonReport.title'

function metricComparisonSelectionStep(selectionView, filterView) {
	return selectionView({
		titleCode: newMetricReportTitle,
		view: NewMetricComparisonViewAdapter,
		viewOptions: {
			filterView
		}
	})
}

const MetricComparisonPath = {
	icon: 'measure-comparison',
	key: newMetricReportTitle,
	steps: [ metricComparisonSelectionStep(orgSelectionView, OrganizationsView),
		metricComparisonSelectionStep(metricSelectionView, MetricsView), {
		titleCode: newMetricReportTitle,
		view: CalendarView,
		validate: function(attrs, opts) {
			return rangePathValidation.rangePathValidation(attrs.range)
		}
	}],
	model: MetricComparisonModel
}

const CompareScorecardItemsFilterPath = {
	steps: [orgSelectionView({
		serverValidate: function(model) {
			return MetricComparisonModel.resolveOrgs(model)
		}
	}), metricSelectionView()],
	model: Backbone.Model
}

export default MetricComparisonPath
export { CompareScorecardItemsFilterPath }

MetricComparisonPath.__filename__ = 'reports/wizard/metric-comparison/metric-comparison-path.js'
